export enum PDF_SECTIONS {
  SECTION_SUMMARY = 'summary',
  ABOUT_COMPANY = 'aboutCompany',
  PRODUCT_AND_SERVICES = 'productAndServices',
  MARKET_ANALYSIS = 'marketAnalysis',
  MARKETING_AND_SALES = 'marketingAndSales',
  BUSINESS_OPERATIONS = 'businessOperations',
  MANAGEMENT_AND_ORGANIZATION = 'managementAndOrganization',
  IMPLEMENTATION_PLAN = 'implementationPlan',
  LEGAL_FRAMEWORK_AND_RISKS = 'legalFrameworkAndRisks',
  FINANCIAL_PLAN = 'financialPlan',
  RAISING_AND_ALLOCATING_FUNDS = 'raisingAndAllocatingFunds',
}
